module.exports = __webpack_public_path__ + "static/media/self_color_portrait_green.220d9f7f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/self_color_portrait_green.png
 ** module id = 296
 ** module chunks = 0
 **/